import { setIn } from 'formik';
// import merge from 'lodash/merge';
import { v4 as uuid } from 'uuid';
import { DefiniteFormFieldDefinition2 } from '@/components/Inputs/FieldCreator';

// TODO: type ya no existe al menos en el top level de los fields. buscar otra forma de detectarlo, o hacer que default sea un campo requerido y deprecar esto

export const makeDefaultValues = <
  F extends DefiniteFormFieldDefinition2<any, any>[],
>(
  fields: F
): F extends DefiniteFormFieldDefinition2<infer V, any>[]
  ? V & Record<`@@${string}`, any>
  : Record<string, any> =>
  fields
    .filter((field) => !!field)
    .reduce((obj, field) => {
      const fieldDef = typeof field === 'function' ? field({} as any) : field;
      if (!fieldDef || fieldDef.default === '@@skip') return obj;
      let def = fieldDef.default !== undefined ? fieldDef.default : '';
      if (fieldDef.default === '@@uuid') def = uuid();
      // if (fieldDef.type === 'date') def = new Date();
      // if (fieldDef.type === 'checkbox') def = false;
      // if (fieldDef.type === 'buttons-row') {
      //   const def = makeDefaultValues(fieldDef.fields);
      //   return merge(obj, def);
      // }
      return setIn(obj, fieldDef.name, def);
    }, {}) as F extends DefiniteFormFieldDefinition2<infer V, any>[]
    ? V & Record<`@@${string}`, any>
    : Record<string, any>;
